/**
 * Composable for handling tag creation in contact forms and imports
 * Consolidates the logic for creating tags and handling feedback
 */
export async function createTag(tagNameOrObject, store, notification, options = {}) {
  const { favourite = false } = options

  try {
    // Handle both string tag names (from AM3InputSelect) and tag objects (from AM3InputTags)
    const tagName = typeof tagNameOrObject === 'string' ? tagNameOrObject : tagNameOrObject.name
    const hasOid = typeof tagNameOrObject === 'object' && tagNameOrObject.oid

    // Skip if tag already exists (has an oid)
    if (hasOid) {
      console.log(`[useTagCreation] Tag "${tagName}" already exists, skipping creation`)
      return tagNameOrObject
    }

    console.log(`[useTagCreation] Creating new tag: "${tagName}"`)

    // Create the tag in the backend
    const createdTag = await store.dispatch('tagModule/ADD_TAG', { name: tagName, favourite })

    if (createdTag) {
      console.log(`[useTagCreation] Tag created successfully:`, createdTag)

      return createdTag
    }

    return null
  }
  catch (error) {
    console.error('[useTagCreation] Error creating tag:', error)

    const tagName = typeof tagNameOrObject === 'string' ? tagNameOrObject : tagNameOrObject.name

    // // Show error notification
    // if (notification) {
    //   notification.push({
    //     type: 'error',
    //     message: `Failed to create tag "${tagName}"`,
    //   })
    // }

    console.error('[useTagCreation] Error creating tag:', error)
    throw error
  }
}
